import React from "react";
import styled from "styled-components";
import { Body6 } from "@arcteryx/components-typography";

export const LabelStyled = styled(Body6).attrs({tag: "label"})`
  display: inline-block;
`;

export const RequiredSpan = styled(Body6).attrs({tag: "span"})`
  color: var(--warning-red);
  margin: 0;
  padding-right: 2px;
`;

const Label = ({ name, required, labelText }) => (
  <LabelStyled className="qa-control-label" id={`labelFor--${name}`} htmlFor={name}>
    {required && <RequiredSpan>*</RequiredSpan>}
    {labelText}
  </LabelStyled>
);

export default Label;
